function readSelectedProjectIds() {
  try {
    const raw = sessionStorage.getItem("selectedCompanies");
    if (!raw || raw === "undefined") return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0);
  } catch {
    return [];
  }
}

function readActiveProjectId() {
  try {
    const ap = localStorage.getItem("activeProjectId");
    const n = ap ? parseInt(ap, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

function readNumericCompanyLocalStorage() {
  try {
    const c = localStorage.getItem("company");
    if (c && /^\d+$/.test(String(c).trim())) {
      const n = parseInt(c, 10);
      if (Number.isFinite(n) && n > 0) return n;
    }
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * id_projeto para GET /setup/snapshot e escopo de etapas — alinha workspace "ativo" às empresas selecionadas.
 * Evita snapshot em projeto A enquanto etapas foram gravadas no projeto B (ex.: primeiro da lista ≠ ativo).
 */
export function resolveSnapshotProjectId(savedProjectIdFromSetup) {
  if (
    savedProjectIdFromSetup != null &&
    Number.isFinite(Number(savedProjectIdFromSetup)) &&
    Number(savedProjectIdFromSetup) > 0
  ) {
    return Number(savedProjectIdFromSetup);
  }
  const selected = readSelectedProjectIds();
  try {
    const ac = sessionStorage.getItem("activeCompany");
    const n =
      ac != null && /^\d+$/.test(String(ac).trim()) ? parseInt(String(ac).trim(), 10) : NaN;
    if (Number.isFinite(n) && n > 0 && selected.includes(n)) return n;
  } catch {
    /* ignore */
  }
  const active = readActiveProjectId();
  if (active && selected.includes(active)) return active;
  if (selected.length) return selected[0];
  if (active) return active;
  return readNumericCompanyLocalStorage();
}

/** Primeiro id_projeto selecionado no painel (sessionStorage), para ?id_projeto / política de idioma. */
export function readPrimaryProjectId() {
  const selected = readSelectedProjectIds();
  if (selected.length) return selected[0];
  return null;
}
